import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Icon } from "../../../shared/components/icon";
import { principalRouteNavigate } from '../../../shared/utilities/const/route';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss'],
  imports: [Icon, RouterLink],
})
export class Footer {
  protected readonly faqRoute = principalRouteNavigate.faq;
}
